import {all} from 'redux-saga/effects';

import {createFetchSagaLatest} from 'utils/sagas';

import {
  fetchRevenueSummary as fetchRevenueSummaryAction,
  fetchRevenueReport as fetchRevenueReportAction
} from './';

import {fetchRevenueSummary, fetchRevenueReport} from 'sdk/reporting';

function* revenueReportingSaga() {
  yield all([
    createFetchSagaLatest(fetchRevenueSummaryAction, fetchRevenueSummary),
    createFetchSagaLatest(fetchRevenueReportAction, fetchRevenueReport)
  ]);
}

export default revenueReportingSaga;
